<template>
    <div>
      <div class="d-flex justify-space-between align-center">
      <h2 class="page-title-bar">
        <img src="@/assets/img/bell-ring.png" style="margin-right: 15px; height: 31px;" />{{ $t("Alert List") }}
      </h2>
      <v-menu v-model="menuOpen" offset-y :close-on-content-click="false" content-class="columnMenu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text small class="manage-btn btn" v-bind="attrs" v-on="on">
            {{ $t("Manage Columns") }}
            <v-icon right :class="{ rotate: menuOpen }">
              mdi-chevron-down
            </v-icon>
          </v-btn>
        </template>
        <v-card class="column-card">
          <v-card-title class="column-header">
            {{ $t("Select Columns") }}
          </v-card-title>
          <v-divider />
          <v-list dense class="select-all">
            <v-list-item>
              <v-checkbox :input-value="isAllSelected" @change="toggleSelectAll" hide-details />
              <v-list-item-title>{{ $t("Select All") }}</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-card-text class="column-list">
            <v-list dense>
              <v-list-item v-for="header in tableHeaders.slice(3)" :key="header.value">
                <v-checkbox v-model="visibleColumns" :value="header.text" hide-details />
                <v-list-item-title class="column-text">{{ header.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider />
          <v-card-actions class="column-footer">
            <v-btn color="error" style="background: #c57171;color: #ffffff !important;width:80px" text small
              @click="menuOpen = false">
              {{ $t("Cancel") }}
            </v-btn>
            <v-spacer />
            <v-btn color="primary" small style="width:80px" @click="menuOpen = false; saveVisibleColumns()">
              {{ $t("Save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
      <div class="">
        <div class="col-9">
          <!-- SEARCH AREA  -->
          <div class="searchArea" style="width: 80%">
            <div class="row">
              <div class="d-flex col-12 align-baseline px-0 py-0">
                <!-- Sensor Name -->
                <v-text-field
                  :label="$t('Sensor ID')"
                  outlined
                  hide-details
                  dense
                  :placeholder="$t('Input Sensor ID')"
                  v-model="searchBy.sensorCode"
                  clearable
                  class="form-select col-3"
                >
                </v-text-field>
                <v-select
                  :label="$t('Type')"
                  :placeholder="$t('Select Type')"
                  outlined
                  dense
                  hide-details
                  v-model="searchBy.alertType"
                  :items="typeList"
                  item-text="text"
                  item-value="val"
                  class="form-select col-3 ml-3"
                >
                </v-select>
                <v-select
                  :label="$t('Status')"
                  :placeholder="$t('Select Status')"
                  outlined
                  dense
                  hide-details
                  v-model="searchBy.status"
                  :items="['Active','Completed']"
                  item-text="text"
                  item-value="val"
                  class="form-select col-3 ml-3"
                >
                </v-select>
                <v-btn class="btn type-search ml-3" text @click="clickSearch()"
                  >{{ $t("Search") }}
                </v-btn>
                <v-btn class="btn type-search ml-3" text @click="clearSearch"
                  >{{ $t("Clear") }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-10">
        <v-data-table
          :headers="filteredTableHeaders"
          :items="tableItems"
          item-key="serialNo"
          :hide-default-footer="true"
          :options.sync="options"
          :items-per-page="rowPerPage"
          :server-items-length="tableItems.length"
          :show-select="false"
          class="tbl-type01 mt-5"
          fixed-header
          must-sort
          :height="
                tableItems && tableItems.length > 8
                  ? '550px'
                  : 'auto'
              "
        >
          <template slot="no-data">
            <v-alert dense color="#697A8A" class="ma-0" style="line-height: 19px">
              <v-icon class="mr-1" color="#fff">mdi-alert-outline</v-icon>
              {{ $t("No data available") }}
            </v-alert>
          </template>
          <template v-slot:[`item.value`]="{ item }">
              <div
                :style="
                  item.type.toUpperCase() === 'HIGH_TEMPERATURE'.toUpperCase() ||
                  item.type.toUpperCase() === 'HIGH_HUMIDITY'.toUpperCase()
                    ? 'color:#FF8097'
                    : 'color: #6DA3F8'
                "
              >
                <div v-if="item.type.toUpperCase() === 'HIGH_TEMPERATURE'.toUpperCase() ||
                item.type.toUpperCase() === 'LOW_TEMPERATURE'.toUpperCase()
                 ">
                  <p v-if="toggleState">{{ item.value }} <span>°</span>C</p>
                <p v-else>
                  {{ ((item.value * 9) / 5 + 32) .toFixed(2)}} <span>°</span>F
                </p>
                </div>
                <div v-else>
                  <p>{{ item.value }}%</p>
                </div>
              </div>
            </template>
          <template v-slot:[`item.deliveryStatus`]="{ item }">
            <div
             :style="{ cursor: !btnActionAlert ? 'pointer' : 'not-allowed' }"
             :class="{ 'disabled-icon': btnActionAlert }"
              @click="openStatusDialog(item)"
            >
           <img src="@/assets/img/info-ico-custom.png" alt="" height="25" />
           </div>
          </template>
          <template v-slot:[`item.assignedTo`]="{ item }">
            {{ item.assignedTo !== null ? convertToString(item.assignedTo) : '-'  }}
          </template>
          <template v-slot:[`item.sensorName`]="{ item }">
            {{ item.sensorName ? item.sensorName : '-' }}
          </template>
          <template v-slot:[`item.duration`]="{ item }">
            {{ item.alertTime !== null && item.alertOffTime !== null ? getUTCtoLocalTimeDuration(item) : '-' }}
          </template>
          <template v-slot:[`item.alertOffTime`]="{ item }">
            {{ item.alertOffTime ? getUTCtoLocal(item.alertOffTime) : '-' }}
          </template>
          <template v-slot:[`item.alertTime`]="{ item }">
            <span>{{ item.alertTime ? getUTCtoLocal(item.alertTime) : '-' }}</span>
          </template>

          <template v-slot:[`item.type`]="{ item }">
            <p
              :style="getColor(item.type)"
            >
              {{ item.type }}
            </p>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <p
              :style="
                item.status === 'ON'
                  ? 'color: #EF726B'
                  : 'color: #9DEB8F'
              "
            >
              {{ item.status === 'ON' ? 'Active' : 'Completed' }}
            </p>
          </template>
        </v-data-table>
        <div class="table-options" v-if="tableItems.length > 0">
          <div></div>
          <div>
            <div class="pageInfo">{{ pageInfoText }}</div>
            <div class="pagination2">
              <label class="pageInfo mr-1" style="position:relative !important;">
                {{ $t("Show") }}
              </label>
              <v-select
                v-model="rowPerPage"
                :items="rowPerPageList"
                :placeholder="$t('Limit')"
                class="form-input pt-0 col rowPerPage"
                dense
                persistent-hint
                outlined
                hide-details
                @change="paging(1)"
              >
                <template v-slot:item="{ item }">
                  {{ `${item}` }}
                </template>
                <template v-slot:selection="{ item }">
                  <span class="selection-v-select"> {{ `${item}` }}</span>
                </template>
              </v-select>
              <span style="font-size: 13px;padding: 8px;">{{$t('Rows')}}</span>

              <div class="mr-2">
                <v-text-field
                  v-model="goToPageInput"
                  class="form-input pt-0 col goToPage ml-1"
                  placeholder="Page"
                  outlined
                  dense
                  hide-details
                  solo
                  @keyup.enter="goToPage(goToPageInput, paging, totalPages)"
                  append-icon="mdi-chevron-right"
                  @keypress="checkIsNumber($event)"
                  @click:append="goToPage(goToPageInput, paging, totalPages)"
                ></v-text-field>
              </div>
              <button
                @click="goTenPageBackwards(page, paging)"
                :class="page < 10 ? 'pagination-nav-disabled' : null"
                class="pagination-nav pagination-nav-prev"
                type="button"
              >
                <img
                  src="@/assets//img/ico-paging-prev.png"
                  alt="이전 10페이지 이동"
                />
              </button>
              <v-pagination
                v-model="page"
                @input="paging"
                :length="totalPages * 1 || 1"
                :total-visible="8"
                color="#2f3b4c"
                style="display: block"
              ></v-pagination>
              <button
                @click="goTenPageForward(page, paging, totalPages)"
                :class="
                  page + 10 > totalPages ? 'pagination-nav-disabled' : null
                "
                class="pagination-nav pagination-nav-next"
                type="button"
              >
                <img
                  src="@/assets//img/ico-paging-next.png"
                  alt="다음 10페이지 이동"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <AlarmNotification
        v-if="notiDialogPopup"
        :notiDialogPopup="notiDialogPopup"
        :alertIdData="alertIdInfo"
        @closeNotiModal="closeNotiModal"
      />
    </div>
  </template>

<script>
import EventBus from '@/plugins/eventBus'
import commons from '@/plugins/commons'
import codes from '@/plugins/codes'
import { mapGetters } from 'vuex'
import Pagenation from '@/mixins/Pagenation'
import AlarmNotification from './model/AlarmNotification.vue'
import moment from 'moment-timezone'
export default {
  mixins: [Pagenation],
  components: {
    AlarmNotification
  },
  data () {
    return {
      toggleState: true,
      rowPerPage: 10,
      notiDialogPopup: false,
      alertIdInfo: {},
      page: 1,
      totalPages: 0,
      pageInfoText: '1 to 1, 1 in total',
      goToPageInput: 1,
      options: {
        sortBy: ['alertTime'],
        sortDesc: [true],
        itemsPerPage: 10
      },
      searchBy: {
        sensorCode: null,
        alertType: null,
        status: null
      },
      typeList: [
        {
          text: this.$t('High Temperature'),
          val: 'HIGH_TEMPERATURE'
        },
        {
          text: this.$t('Low Temperature'),
          val: 'LOW_TEMPERATURE'
        },
        {
          text: this.$t('High Humidity'),
          val: 'HIGH_HUMIDITY'
        },
        {
          text: this.$t('Low Humidity'),
          val: 'LOW_HUMIDITY'
        }
      ],
      tableItems: [],
      isMounted: false,
      btnActionAlert: false,
      menuOpen: false,
      visibleColumns: []
    }
  },
  computed: {
    isAllSelected () {
      return (
        this.tableHeaders.length > 0 &&
        this.visibleColumns.length === this.tableHeaders.length - 3
      )
    },
    filteredTableHeaders () {
      return this.tableHeaders.filter(h =>
        h.value === 'serialNo' ||
        h.value === 'sensorCode' ||
        h.value === 'sensorName' ||
        this.visibleColumns.includes(h.text)
      )
    },
    rowPerPageList () {
      return [5, 10, 20, 50, 100]
    },
    ...mapGetters({
      store: 'dataStore/GET_SELECTED_STORE'
    }),
    tableHeaders () {
      return [
        {
          text: this.$t('#'),
          sortable: false,
          value: 'serialNo'
        },
        {
          text: this.$t('SENSOR ID'),
          sortable: false,
          value: 'sensorCode'
        },
        {
          text: this.$t('SENSOR NAME'),
          sortable: false,
          value: 'sensorName'
        },
        {
          text: this.$t('ALERT TIME'),
          sortable: true,
          value: 'alertTime'
        },
        {
          text: this.$t('ALERT OFF TIME'),
          sortable: true,
          value: 'alertOffTime'
        },
        {
          text: this.$t('DURATION (Hrs:Min)'),
          sortable: false,
          value: 'duration'
        },
        {
          text: this.$t('LOCATION'),
          sortable: false,
          value: 'assignedTo'
        },
        {
          text: this.$t('TYPE'),
          sortable: false,
          value: 'type'
        },
        {
          text: this.$t('VALUE'),
          sortable: false,
          value: 'value'
        },
        {
          text: this.$t('DELIVERY STATUS'),
          sortable: false,
          value: 'deliveryStatus'
        },
        {
          text: this.$t('STATUS'),
          sortable: false,
          value: 'status'
        }
      ]
    }
  },
  watch: {
    options: {
      handler () {
        if (!this.isMounted) return
        this.getAlertListDetails(this.page)
      },
      deep: true
    },
    store: {
      handler () {
        if (
          this.store === undefined ||
          !this.store.code ||
          this.store.code === ''
        ) {
          EventBus.$emit('openSelectedStores')
          this.tableItems = []
          this.totalPages = 0
          this.pageInfoText = '0 to 0, 0 in total'
          this.page = 1
          this.goToPageInput = 1
          this.searchBy = { sensorCode: null, alertType: null, status: null }
          return
        }
        this.paging(1)
      }
    },
    page: {
      handler (page) {
        this.goToPageInput = page
      }
    }
  },
  created () {
    if (localStorage.getItem('tempIndicator') !== null) {
      this.toggleState = JSON.parse(localStorage.getItem('tempIndicator'))
    } else {
      this.toggleState = true
      localStorage.setItem('tempIndicator', 'true')
    }
  },
  mounted () {
    this.$store.dispatch('auth/getDisabledBtn', '13103').then(flag => {
      this.btnActionAlert = flag
    })
    EventBus.$emit('enableSelectedStores', true)
    if (
      this.store === undefined ||
      !this.store.code ||
      this.store.code === ''
    ) {
      EventBus.$emit('openSelectedStores')
      return
    }
    this.getAlertListDetails(1)
    this.togetCustomCloumn()
  },
  methods: {
    toggleSelectAll (value) {
      if (value) {
        this.visibleColumns = this.tableHeaders.map(h => h.text).slice(3)
      } else {
        this.visibleColumns = []
      }
    },
    togetCustomCloumn () {
      const params = { userId: this.$store.state.auth.user.account, type: 'ALERT_LIST' }
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.getCustomColoumnlist.method,
          codes.requests.getCustomColoumnlist.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            console.log(res.data)
            const data = res.data
            const apiColumns = data['13200'] || []
            if (apiColumns.length > 0) {
              this.visibleColumns = apiColumns.filter(text =>
                this.tableHeaders.some(h => h.text === text)
              )
            } else {
              this.visibleColumns = []
            }
          } else {
            this.visibleColumns = this.tableHeaders.map(h => h.text)
          }
        })
        .catch(error => {
          console.log(error)
          this.visibleColumns = this.tableHeaders.map(h => h.text)
        })
    },
    saveVisibleColumns () {
      const body = {
        13200: this.visibleColumns
      }
      const params = { userId: this.$store.state.auth.user.account, type: 'ALERT_LIST' }
      this.$utils
        .callAxiosWithBody(
          codes.requests.updateCustomColoumnlist.method,
          codes.requests.updateCustomColoumnlist.url,
          body,
          { params: params }
        )
        .then(res => {
          if (res.status === 200) {
            console.log(res.data)
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
            this.togetCustomCloumn()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    goToPage (goToPageInput, paging, totalPages) {
      if (totalPages < goToPageInput) {
      } else {
        paging(Number(goToPageInput))
      }
    },
    convertToString (data) {
      return data.toString()
    },
    clickSearch () {
      this.paging(1)
    },
    getColor (type) {
      if (type === 'HIGH_TEMPERATURE') return 'color: #EF726B'
      if (type === 'LOW_TEMPERATURE') return 'color: #6DA3F8'
      if (type === 'HIGH_HUMIDITY') return 'color: #EF726B'
      if (type === 'LOW_HUMIDITY') return 'color: #7D98DA'
      else return '#EF726B'
    },
    getUTCtoLocal (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    getUTCtoLocalTimeDuration (item) {
      const startTime = moment(item.alertTime).format('YYYY-MM-DD HH:mm:ss')
      const endTime = moment(item.alertOffTime).format('YYYY-MM-DD HH:mm:ss')
      const start = moment(startTime, 'YYYY-MM-DD HH:mm:ss')
      const end = moment(endTime, 'YYYY-MM-DD HH:mm:ss')
      const duration = moment.duration(end.diff(start))
      const hours = Math.floor(duration.asHours())
      const minutes = duration.minutes()
      const formattedDuration = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
      return formattedDuration
    },
    clearSearch () {
      this.searchBy = {
        sensorCode: null,
        alertType: null,
        status: null
      }
      this.paging(1)
    },
    paging (page) {
      this.page = Number(page)
      this.goToPageInput = page
      this.isMounted = false
      this.getAlertListDetails(this.page)
    },
    openStatusDialog (data) {
      if (!this.btnActionAlert) {
        this.notiDialogPopup = true
        this.alertIdInfo = data
      }
    },
    closeNotiModal () {
      this.notiDialogPopup = false
    },
    getPageInfoText (headers, tabelItems) {
      return (
        headers['x-number'] * 1 * headers['x-size'] +
          1 +
          ' to ' +
          (headers['x-number'] * 1 * headers['x-size'] + tabelItems.length) +
          ', ' +
          headers['x-totalelements'] * 1 +
          ' in total'
      )
    },
    handleGetPrResponse (res) {
      const headers = res.headers
      this.tableItems = res.data.alertHistory.map((obj, idx) => {
        return {
          serialNo: headers['x-number'] * 1 * headers['x-size'] + idx + 1,
          ...obj
        }
      })
      this.pageInfoText = commons.getPageInfoText(res.headers)
      if (commons.isValidStr(res.headers['x-totalpages'])) {
        this.totalPages = res.headers['x-totalpages'] * 1
      }
      this.selected = []
    },
    handleGetPrError (error) {
      this.tableItems = []
      const headers = {}
      headers['x-totalelements'] = 0
      this.pageInfoText = commons.getPageInfoText(headers)
      this.totalPages = 0
      this.selected = []
      EventBus.$emit(
        'messageAlert',
        this.$t(error.response.data.responseMessage),
        'error'
      )
      console.debug(`Could not find any Alert. ${error}`)
    },
    buildSearchParams (params, searchBy) {
      if (searchBy.sensorCode !== null) {
        params.sensorCode = searchBy.sensorCode
      }
      if (!commons.isNull(searchBy.alertType)) params.alertType = searchBy.alertType
      if (!commons.isNull(searchBy.status)) {
        if (searchBy.status === 'Active') {
          params.status = 'ON'
        } else {
          params.status = 'OFF'
        }
      }
      return params
    },
    getSortKey (sortKey) {
      switch (sortKey) {
        case 'alertTime':
          sortKey = 'alertTime'
          break
        default:
          break
      }
      return sortKey
    },
    buildParams () {
      const { sortBy, sortDesc, itemsPerPage } = this.options
      this.options.itemsPerPage = Number(this.rowPerPage)
      let params = { store: this.store.code }
      let sort = null
      if (commons.isSorting(sortBy, sortDesc)) {
        let sortKey = this.getSortKey(sortBy[0])
        const sortOrder = sortDesc[0]
        if (sortKey === 'alertTime') sortKey = 'alertTime'
        sort = `${sortKey},${sortOrder ? 'desc' : 'asc'}`
      }
      if (sort !== null) params.sort = sort
      if (itemsPerPage > 0) params.size = this.rowPerPage
      params = this.buildSearchParams(params, this.searchBy)
      params.company = this.$store.state.auth.user.company
      params.store = this.store.code
      return params
    },
    getAlertListDetails (page) {
      const params = this.buildParams()
      if (page !== null) params.page = page - 1
      const config = { params }
      this.$utils
        .callAxios(
          codes.requests.getAlertHistory.method,
          codes.requests.getAlertHistory.url,
          config
        )
        .then(res => {
          this.isMounted = true
          if (res.data && res.status === 200) {
            this.handleGetPrResponse(res)
          } else {
            this.tableItems = []
            this.totalPages = 0
            this.selected = []
            this.pageInfoText = ''
          }
        })
        .catch(error => {
          this.isMounted = true
          this.handleGetPrError(error)
          console.log(error)
        })
    }
  }
}
</script>

  <style scoped>
  .circle {
    height: 15px;
    width: 15px;
    border-radius: 50%;
  }

  </style>
  <style>
   .disabled-icon {
  opacity: 0.5 !important;
  pointer-events: none !important;
}
.columnMenu {
  max-width: 200px;
  top: 250px;
}

.columnMenu {
  max-width: 260px;
}

.column-card {
  width: 100%;
  max-width: 260px;
}

.column-header {
  font-weight: 600;
  font-size: 14px;
  padding: 12px 16px;
}

.column-list {
  max-height: 260px;
  overflow-y: auto;
  padding: 0 8px;
}

.column-text {
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.column-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 8px 12px;
}

.manage-btn {
  max-width: 200px;
  white-space: nowrap;
}

.rotate {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
</style>
